// extracted by mini-css-extract-plugin
module.exports = {"addReleaseBtn":"AddReleaseForm_addReleaseBtn__O7amw"};